import React, {useEffect} from 'react';
import * as yup from 'yup';
import {getLanguage, t} from 'react-switch-lang';
import {validNameandNumberEngMneRegex} from '../../../../utils/const';
import {FormProvider, useForm} from 'react-hook-form';
import {yupResolver} from '@hookform/resolvers';
import {updateServiceProviders} from '../../../../services/externalizations/serviceProvidersService';
import Toast from '../../../../components/toast/Toast';
import {Col, Row} from 'react-bootstrap';
import Label from 'reactstrap/lib/Label';
import InputText from '../../../../components/FormFields/InputText';
import Swal from 'sweetalert2';

const PreviewServiceProvider = (props) => {
  const {
    name,
    tin} = props?.data
  const lang = getLanguage();
  const schema = yup.object().shape({
    name: yup
      .string()
      .trim()
      .required(t('message.fieldRequired'))
      .matches(validNameandNumberEngMneRegex, t('message.fieldNotValid'))
      .max(100, `${t('message.max', {max: 100})}`)
      .min(3, `${t('message.min', {min: 3})}`),
    tin: yup
      .string()
      .trim()
      .required(t('message.fieldRequired'))
      .max(13, `${t('message.max', {max: 13})}`)
      .min(7, `${t('message.min', {min: 7})}`)
  });
  const methods = useForm({
    resolver: yupResolver(schema),
  });

  const {handleSubmit, watch, errors, register, setValue} = methods;
  const submitForm = async (data) => {
    const dataToSubmit = {
      id: props?.data?.id,
      name: data?.name,
      tin: data?.tin
    }
    try {
      const res = await updateServiceProviders(props?.data?.id, dataToSubmit)
      if (res.status === 200) {
        Toast.fire({
          title: t('message.updateSuccess2', {
            entity: t('externalization.serviceProvider'),
          }),
          icon: 'success',
        });
        props.setRowChanged();
        props.toggleModal();
      }
    }
    catch (err) {
      if (err?.response?.data?.code === 'service-provider-already-exists') {
        Swal.fire({
          text:
            lang === 'eng'
              ? err?.response?.data?.description
              : t('message.serviceProviderAlreadyExists'),
          icon: 'error',
        });
      } else {
        Toast.fire({
          title: t('message.errorApi'),
          icon: 'error',
        });
      }
    }
  };

  const handleCancel = e => {
    e.preventDefault();
    props.toggleModal();
    props.setDisabled();
  };
  useEffect(() => {
    return () => {
      props.setDisabled();
    };
  }, []);
  return (
    <FormProvider {...methods}>
      <form onSubmit={handleSubmit(submitForm)}>
        <Row className="mb-4">
          <Col sm={12}>
            <Label for="name"> {t("externalization.riskProponentForm.serviceProvider")}</Label>
            <InputText
              type="text"
              id="name"
              name="name"
              defaultValue={name}
              className={
                "form-control " +
                (errors.name !== undefined ? "error-field" : "")
              }
              disabled={props.disabled}
              placeholder={t("externalization.riskProponentForm.placeholder.serviceProvider")}
            />
          </Col>
        </Row>
        <Row className="mb-4">
          <Col sm={12}>
            <Label for="tin"> {t("externalization.tin")}</Label>
            <InputText
              type="text"
              id="tin"
              name="tin"
              defaultValue={tin}
              className={
                "form-control " +
                (errors.tin !== undefined ? "error-field" : "")
              }
              disabled={props.disabled}
              placeholder={t("externalization.placeholder.tin")}
            />
          </Col>
        </Row>
        {!props.disabled && (
        <Row className="submit-buttons-container mx-0">
          <Col sm={12} className="text-right px-0">
            <div className="submit">
              <button
                className="primary cancel"
                type="reset"
                onClick={(e) => handleCancel(e)}>
                {t("buttons.cancelBtn")}
              </button>
              <button className="primary">
                {t("buttons.saveBtn")}
              </button>
            </div>
          </Col>
        </Row>)}
      </form>
    </FormProvider>
  );
};

export default PreviewServiceProvider;